var map = {
	"./assets/en/image3_2x.jpeg": 44498,
	"./assets/image3_2x.jpeg": 67507,
	"pages/home/assets/en/image3_2x.jpeg": 44498,
	"pages/home/assets/image3_2x.jpeg": 67507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60981;